import { createReducer } from 'typesafe-actions';
import { RootAction } from 'actions';
import { getMachineConfigAC, setMachineConfigDevice } from 'actions/machineConfigActions';
import { MachineConfig } from '../store/storeTypes';

const INIT_STATE: MachineConfig = {
  params: [],
  device: {
    id: '',
    name: '',
    imageUrl: '',
  },
  isLoading: false,
};

const reducer = createReducer<MachineConfig, RootAction>(INIT_STATE)
  .handleAction(getMachineConfigAC.request, (state, action) => {
    return { ...state, isLoading: true };
  })
  .handleAction(getMachineConfigAC.success, (state, action) => {
    return { ...state, params: action.payload, isLoading: false };
  })
  .handleAction(getMachineConfigAC.failure, (state, action) => {
    return { ...state, isLoading: false };
  })
  .handleAction(setMachineConfigDevice, (state, action) => {
    return { ...state, device: action.payload };
  });

export default reducer;
